<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-row dense>
                <v-col
                        cols="12">
                    <img
                            class="mr-4 elevation-3"
                            width="400px"
                            :src="reply.field_drawing.url">
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    export default {
        name: "FieldDrawingReply",
        props: {
            reply: {type: Object, default: () => {}}
        }
    }
</script>

<style scoped>

</style>